import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const ChevronThickRight = ({
	size,
	...props
}: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M23 16C23.0001 15.7372 22.9483 15.4769 22.8477 15.2341C22.7471 14.9913 22.5997 14.7708 22.4138 14.585L12.4138 4.58498C12.2279 4.39933 12.0074 4.25209 11.7647 4.15168C11.5219 4.05126 11.2618 3.99964 10.9991 3.99976C10.7365 3.99987 10.4764 4.05172 10.2337 4.15235C9.99111 4.25298 9.77067 4.40041 9.58501 4.58623C9.39936 4.77205 9.25212 4.99262 9.15171 5.23535C9.05129 5.47807 8.99967 5.7382 8.99979 6.00087C8.9999 6.26354 9.05175 6.52362 9.15238 6.76626C9.25301 7.00889 9.40044 7.22933 9.58626 7.41498L18.1713 16L9.58626 24.585C9.21115 24.9601 9.00041 25.4689 9.00041 25.9994C9.00041 26.5299 9.21115 27.0386 9.58626 27.4137C9.96138 27.7889 10.4701 27.9996 11.0006 27.9996C11.5311 27.9996 12.0399 27.7889 12.415 27.4137L22.415 17.4137C22.7897 17.0386 23.0001 16.5301 23 16Z" />
	</svg>
);

export default ChevronThickRight;
